import { render, staticRenderFns } from "./CopyCodeButton.vue?vue&type=template&id=2fb9848c"
import script from "./CopyCodeButton.vue?vue&type=script&lang=ts"
export * from "./CopyCodeButton.vue?vue&type=script&lang=ts"
import style0 from "./CopyCodeButton.vue?vue&type=style&index=0&id=2fb9848c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports